import {setSystemToLowercase} from './shared/serverFunctions';

/**
 * Locations
 * DBAs
 * Companies
 * Location Types
 * Districts
 * Price Levels
 * Additional taxes
 *
 * GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE
 */
export const RESOURCES = {
    "Locations": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let uri;
            if (params && params.filter && params.filter.locations_list_filter) {
                // If a single Location filter has been passed, get a single Location
                params.id = params.filter.locations_list_filter;
                uri = localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/locationById/" + system + "/" + params.id
            } else if (params && params.filter && params.filter.filter_by === 'filter_company') {
                // Get Locations by Company
                uri = localStorage.getItem('server') + "/api/v5/admin/locationsByCompany/" + system + "/" + params.filter.filter_company;
            } else if (params && params.filter && params.filter.filter_by === 'filter_dba') {
                // Get Locations by DBA
                uri = localStorage.getItem('server') + "/api/v5/admin/locationsByDba/" + system + "/" + params.filter.filter_dba;
            } else if (params && params.filter && params.filter.filter_by === 'filter_district') {
                // Get Locations by District
                uri = localStorage.getItem('server') + "/api/v5/admin/locationsByDistrict/" + system + "/" + params.filter.filter_district;
            } else if (params && params.filter && params.filter.filter_by === 'filter_location') {
                // Get Locations by Location ID
                uri = localStorage.getItem('server') + "/api/v5/admin/locationsById/" + system + "/" + params.filter.filter_location;
            } else if (params && params.filter && params.filter.filter_by === 'filter_all_locations') {
                // Get All Locations
                uri = localStorage.getItem('server') + "/api/v5/admin/locations/" + system + "?params=" + JSON.stringify(params);
            } else if (params && params.filter && params.filter.filter_by === 'filter_state') {
                // Get Locations by State
                uri = localStorage.getItem('server') + "/api/v5/admin/locationsByState/" + system + "/" + params.filter.filter_state;
            } else {
                // Get all Locations (used by virtualized select components)
                uri = localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/locations/" + system + "?params=" + JSON.stringify(params);
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": uri
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Location",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/locationById/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            // Populate IDs and remove their objects
            let locationParams = populateLocationParams(params);
            return {
                "type": "upsert",
                "data": locationParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertLocation"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            // Populate IDs and remove their objects
            let locationParams = populateLocationParams(params);
            return {
                "type": "upsert",
                "data": locationParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertLocation"
            }
        }
    },
    "LocationNames": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/locationNames/" + system + "?params=" + JSON.stringify(params)
            }
        }
    },
    "LocationsForInventory": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/locationsForInventory/" + system + "?params=" + JSON.stringify(params)
            }
        }
    },
    "LocationsForTransfer": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/locationsForTransfer/" + system + "?params=" + JSON.stringify(params)
            }
        }
    },
    "LocationsForStatus": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/locationsForStatus/" + system + "?params=" + JSON.stringify(params)
            }
        }
    },
    "LocationTSYSTransactionKey": {
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "TSYS Transaction Key",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/generateTsysTransactionKey/" + system + "/" + params.location_id
            }
        },
    },
    "DBAs": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "DBAs",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/dbas/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "DBA",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/dba/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            // Populate IDs and remove their objects
            let dbaParams = populateDbaParams(params, true);
            return {
                "type": "upsert",
                "data": dbaParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertDba"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            // Populate IDs and remove their objects
            let dbaParams = populateDbaParams(params, false);
            return {
                "type": "upsert",
                "data": dbaParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/dba"
            }
        }
    },
    "Companies": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Companies",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/companies/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Company",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/company/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/company"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/company"
            }
        }
    },
    "LocationTypes": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Location Types",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/locationTypes/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Location Type",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/locationType/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/locationType"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/locationType"
            }
        }
    },
    "Districts": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Districts",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/districts/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "District",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/district/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/district"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/district"
            }
        }
    },
    "PriceLevels": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            params.sort.field = 'name';
            return {
                "type": "list",
                "method": "GET",
                "title": "Price Levels",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/priceLevels/" + system
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            if (!params.name && params.id) {
                params.name = params.id;
            }
            return {
                "type": "item",
                "method": "GET",
                "title": "Price Level",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/priceLevel/" + system + "/" + params.name
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/priceLevel"
            }
        },
        UPDATE: function (params) {
            // Deprecated
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LocationDomainManager/priceLevel"
            }
        }
    },
    "AdditionalTaxes": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            params.sort.field = 'name';
            return {
                "type": "list",
                "method": "GET",
                "title": "Additional Taxes",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/additionalTaxes/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Additional Tax",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/additionalTax/" + system + "/" + encodeURI(params.id)
            }
        },
        CREATE: function (params) {
            let atParams = populateAdditionalTaxParams(params);
            atParams.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": atParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/createSystemAdditionalTax"
            }
        },
        UPDATE: function (params) {
            let atParams = populateAdditionalTaxParams(params);
            atParams.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": atParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/editSystemAdditionalTax"
            }
        }
    }
};

/*
 * Populate flat ID values for Locations and remove objects
 */
const populateLocationParams = (params) => {
    // Populate the required ID fields
    params.data.dba_id = params.data.dba.id;
    params.data.company_id = params.data.company.id;
    params.data.district_id = params.data.district.id;
    params.data.location_type_id = params.data.location_type.id;
    if (params.data.price_level) {
        params.data.price_level_name = params.data.price_level.name;
        delete params.data.price_level;
    }

    // Populate/overwrite Additional Taxes
    let additional_taxes = [];
    if (params.data.additional_tax_objects && params.data.additional_tax_objects.length > 0) {
        for (let item of params.data.additional_tax_objects) {
            additional_taxes.push(item.machine_name);
        }
    }
    params.data.additional_taxes = additional_taxes;

    // Overwrite any line breaks in Receipt Messaging with a special character set
    let receiptMsg = stripTags(params.data.receipt_message);
    receiptMsg = receiptMsg.replace(/(?:\r\n|\r|\n)/g, "&br;");
    params.data.receipt_message = receiptMsg;

    // Set Close Transfer Warehouse
    let transferToggle = params.data.close_transfer_warehouse_toggle;
    let transferWarehouse = params.data.close_transfer_warehouse;
    let transferOther = params.data.close_transfer_warehouse_list;
    if (!transferToggle && transferOther && parseInt(transferOther, 10) >= 0 && (transferOther !== transferWarehouse)) {
        params.data.close_transfer_warehouse = transferOther;
    }
    if (!params.data.close_transfer_warehouse) {
        params.data.close_transfer_warehouse = params.data.id;
    }

    if (params.data.gateway_account_modified) {
        // Clear Gateway Transaction Key if credentials were modified
        params.data.gateway_account.transaction_key = '';
    } else if (params.data.gateway_account_transaction_key) {
        // If a new key was generated, set it
        params.data.gateway_account.transaction_key = params.data.gateway_account_transaction_key;
    }


    // trim text inputs
    params.data.name = params.data.name ? params.data.name.trim() : params.data.name;
    params.data.address = params.data.address ? params.data.address.trim() : params.data.address;
    params.data.city = params.data.city ? params.data.city.trim() : params.data.city;
    params.data.zipcode = params.data.zipcode ? params.data.zipcode.trim() : params.data.zipcode;
    params.data.telephone = params.data.telephone ? params.data.telephone.trim() : params.data.telephone;
    params.data.county = params.data.county ? params.data.county.trim() : params.data.county;
    params.data.gateway_account.merchant_id = params.data.gateway_account.merchant_id ? params.data.gateway_account.merchant_id.trim() : params.data.gateway_account.merchant_id;

    // Remove objects
    delete params.data.additional_tax_objects;
    delete params.data.additionalTaxesSelectField;
    delete params.data.close_transfer_warehouse_toggle;
    delete params.data.close_transfer_warehouse_list;
    delete params.data.id_check;
    delete params.data.gateway_account_modified;
    delete params.data.gateway_account_transaction_key;

    return params;
};

/*
 * Populate flat Name values for DBAs and remove objects
 */
const populateDbaParams = (params, isCreating) => {
    // Populate the required ID fields
    if (isCreating) {
        if (params.data.price_level) {
            params.data.price_level_name = params.data.price_level.name;
            delete params.data.price_level;
        }
    }

    // Populate/overwrite Additional Taxes
    let additional_taxes = [];
    if (params.data.additional_tax_objects && params.data.additional_tax_objects.length > 0) {
        for (let item of params.data.additional_tax_objects) {
            additional_taxes.push(item.machine_name);
        }
    }
    params.data.additional_taxes = additional_taxes;

    // Overwrite any line breaks in Receipt Messaging with a special character set
    let receiptMsg = stripTags(params.data.receipt_message);
    receiptMsg = receiptMsg.replace(/(?:\r\n|\r|\n)/g, "&br;");
    params.data.receipt_message = receiptMsg;

    delete params.data.additional_tax_objects;
    delete params.data.additionalTaxesSelectField;

    return params;
};

const populateAdditionalTaxParams = (params) => {
    delete params.data.id;
    delete params.data.tax_rate_percent;

    return params;
};

const stripTags = (str) => {
    return str.replace(/(<([^>]+)>)/ig,"");
};


export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "DBAs"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseLocationsResourceMap.js